import React from 'react';

import { flagStyles } from '../settings';

const SvgIQ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2520px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIQ;
